import { StationNavigatorBreadcrumb } from '@app/components/base/stations/StationNavigatorBreadcrumb';
import { Page } from '@app/components/page/Page';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { FragmentsModule } from '@app/modules/fragments/index';
import { useIntl } from 'react-intl';
import { FragmentIcon } from '../../components/FragmentIcon';
import { FragmentsList_V3 } from './FragmentsList_V3';

export function FragmentsListV3Page() {
  const station = useActiveStation();
  const { $t } = useIntl();

  const title = $t({
    id: 'fragments.title',
    defaultMessage: 'Fragmentos',
  });

  return (
    <Page htmlTitle={`${title} | ${station.name}`}>
      <Page.Header
        icon={<FragmentIcon />}
        title={[
          title,
          <StationNavigatorBreadcrumb
            key={station.id}
            basePath={FragmentsModule.basePath}
            activeId={station.id}
          />,
        ]}
      />
      <FragmentsList_V3 key={station.id} station={station} />
    </Page>
  );
}
